/* Mamapachita · La pared (alejarse). assets/mp-cuadro-pared.js, cargado con defer por blocks/mp-cuadro-pared.liquid.
   Al elegir una medida (cualquier radio cuyo value sea el data-medida de un grupo), la obra cambia de tamano en la pared,
   al instante y sin transicion. El servidor ya pinta la medida elegida: esto solo cubre los milisegundos de antes. */
(function () {
  if (window.MPPared && window.MPPared.sincronizar) return;
  function cada(raiz, sel, fn) { Array.prototype.forEach.call(raiz.querySelectorAll(sel), fn); }
  function delMismo(bloque, radio) {
    var id = bloque.getAttribute('data-producto');
    return !id || (radio.name || '').slice(-(id.length + 1)) === '-' + id;
  }
  function pintar(bloque, valor, avisar) {
    var g = null, fila = null;
    cada(bloque, '[data-medida]', function (n) { if (n.getAttribute('data-medida') === valor) g = n; });
    if (!g) return false;
    cada(bloque, '[data-medida]', function (n) { if (n === g) n.removeAttribute('hidden'); else n.setAttribute('hidden', ''); });
    cada(bloque, '[data-fila]', function (f) {
      var si = f.getAttribute('data-fila') === valor;
      f.classList.toggle('is-elegida', si);
      if (si) { f.setAttribute('aria-current', 'true'); fila = f; } else f.removeAttribute('aria-current');
    });
    var svg = bloque.querySelector('svg[role="img"]');
    if (svg) svg.setAttribute('aria-label', g.getAttribute('data-aria'));
    var vivo = bloque.querySelector('[aria-live]');
    if (avisar && vivo && fila) vivo.textContent = 'Medida ' + valor + ', ' + fila.getAttribute('data-precio');
    return true;
  }
  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!r || r.type !== 'radio') return;
    cada(document, '.mp-gpared', function (b) { if (delMismo(b, r)) pintar(b, r.value, true); });
  }, true);
  function sincronizar() {
    cada(document, '.mp-gpared', function (b) {
      var hecho = false;
      cada(document, 'input[type="radio"]:checked', function (r) { if (!hecho && delMismo(b, r)) hecho = pintar(b, r.value, false); });
    });
  }
  window.MPPared = window.MPPared || {};
  window.MPPared.sincronizar = sincronizar;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sincronizar);
  else sincronizar();
})();
